function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export var isObject = function isObject(value) {
  return value !== null && _typeof(value) === 'object';
};
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
export var isString = function isString(value) {
  return typeof value === 'string';
};
export var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
export var isNumber = function isNumber(value) {
  return typeof value === 'number';
};
export var isUndef = function isUndef(value) {
  return typeof value === 'undefined';
};